import React from 'react';
import { Constants } from 'utils';
import moment from 'moment';
import { ViewIcon, PaperclipIcon } from 'assets/icons';

interface Props {
  onClose?: any;
  item?: any;
}

class ModalView extends React.Component<Props> {
  state = {};

  render() {
    const { item } = this.props;

    return (
      <div id="modal-view-preparation">
        {item != null && (
          <div className="container-modal">
            <p className="number">
              {item.number_format} /{' '}
              {moment(item.created_at).format('DD-MM-YYYY')}
            </p>
            <p className="subtitle">Cliente</p>
            <p>{item.user?.full_name}</p>
            <p>
              <span>CI </span>
              {item.user?.full_document}
            </p>

            <div className="lawyer">
              <p className="subtitle">Abogado</p>
              <p>{item.lawyer?.full_name}</p>
              <p>
                <span>CI </span>
                {item.lawyer?.full_document}
              </p>
              <p>
                <span>Inpre </span>
                {item.lawyer?.lawyer_document}
              </p>
            </div>

            <p className="location">
              {item?.state?.name} - {item?.city?.name}
            </p>
          </div>
        )}
      </div>
    );
  }
}

export default ModalView;
